<template>
  <div class="speeddial-holder">

    <div class="speeddial-menu">
        <ul>
          <slot></slot>
        </ul>
  	</div>

    <el-tooltip effect="dark" content="Device Type" placement="bottom" :manual="true" v-model="showTooltip">
      <span v-on:mouseenter="showTooltip = !visible" v-on:mouseleave="showTooltip = false">
        <div @click="showHandle" class="speeddial-btn speeddial-btn__parent" :class="{open: visible}">
          <div ref="icon" class="icon-inner">
            <transition name="icon" tag="div" v-on:before-enter="leave" v-on:enter="enter" v-on:leave="leave">
              <div class="icon-inner" :key="icon" v-html="icon"></div>
            </transition>
          </div>
      	</div>
      </span>
    </el-tooltip>
  </div>
</template>

<script>
 export default {
   name: 'SpeedDialMenu',

   componentName: 'SpeedDialMenu',

   data() {
     return {
       visible      : false,
       icon         : null,
       showTooltip  : false
     }
   },

   props: {
     delay: {
       type: Number,
       default: 50
     }
   },

   mounted() {
     this.$children.map(el => {
       el.$on('click', (e) => {
         this.icon = el.$vnode.elm.childNodes[0].outerHTML;
         this.toggleVisbility(false);
       });
     })
   },
   beforeDestroy() {
     this.$children.map(el => {
       el.$off('click');
     });
   },
   methods: {
     toggleVisbility(visibility){
       this.visible = visibility !== undefined? visibility: !this.visible;
     },
     enter(el){
       el.style.transform = 'scale(1)'
     },
     leave(el){
       el.style.transform = 'scale(0.3)'
     },
     showHandle(el){
       this.toggleVisbility();
       this.$emit('click', el);
       this.showTooltip = !this.visible;
     }
   }
 }
</script>

<style lang="scss" scoped>
  @import '~static/mixins/global';
  @import '~static/mixins/variables';

  .icon-inner{
    height: inherit;
  }

  .icon-enter-active, .icon-leave-active {
   transition: all .18s;
   transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  }

  .icon-enter-to {
   opacity: 1;
  }
  .icon-leave-to{
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// SpeedDialMenu.vue?1b649b08